"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var TypeLabel = function TypeLabel(_ref) {
  var text = _ref.text,
      type = _ref.type,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["text", "type", "className"]);

  return /*#__PURE__*/_react.default.createElement(StyledLabel, _extends({
    className: className ? "".concat(type + ' ' + className) : type
  }, otherProps), text);
};

var StyledLabel = _styledComponents.default.div.withConfig({
  displayName: "StyledLabel"
})(["font-family:", ";font-size:1.4rem;font-weight:bold;padding:3px 18px;border-radius:5px;min-width:93px;text-align:center;color:", ";background:", ";display:inline-block;&.prospect{color:", ";background:", ";}&.customer{color:", ";background:", ";}&.lead{color:", ";background:", ";}&.guarantee{color:", ";background:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.labels.defaultText;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.labels.default;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.labels.prospectText;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.labels.prospect;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.labels.customerText;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.labels.customer;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.labels.leadText;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.labels.lead;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.labels.guaranteeText;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.labels.guarantee;
});

TypeLabel.defaultProps = {
  text: 'Prospect',
  type: 'default',
  otherProps: {}
};
TypeLabel.propTypes = {
  /** The text the label should contain */
  text: _propTypes.string,

  /** The type of the label */
  type: _propTypes.string,

  /** Custom className that will be added on top of the type's className */
  className: _propTypes.string,
  otherProps: _propTypes.object
};
var _default = TypeLabel;
exports.default = _default;